<template>
    <li>
        <div class="p-4 flex items-center group">
            <div class="grow">
                <div class="font-bold text-center">
                    {{ users ? $t("pairing.nousers") : $t("common.noentry") }}
                </div>
            </div>
        </div>
    </li>
</template>

<script>

export default {
  props: {
    users: {
      type: Boolean,
      default: false
    },
  }
};
</script>
